module.exports = __webpack_public_path__ + "static/img/page1-icon1.9dbd643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page1-icon1.png
// module id = 9GIy
// module chunks = 216